export enum FieldValidator {
  nenhum = 0,
  aoMenos2Palavras = 1,
  beneficioPrevidencia = 2,
  cep = 3,
  chassi = 4,
  cmc7 = 5,
  cnpj = 6,
  cpf = 7,
  data = 8,
  dataFutura = 9,
  inscricaoEstadual = 10,
  letraENumero = 11,
  lONGPOSITIVO = 12,
  modulo11 = 13,
  numAutorizacaoAnvisa = 14,
  placa = 15,
  renavam = 16,
  somenteAlgarismo = 17
}
